
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5RjyS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $455dbc852db66eb4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $455dbc852db66eb4$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': "Adicionar rea\xe7\xe3o",
    'fabric.reactions.error.unexpected': "As rea\xe7\xf5es est\xe3o indispon\xedveis no momento",
    'fabric.reactions.loading': 'Carregando...',
    'fabric.reactions.more.emojis': 'Mais emojis',
    'fabric.reactions.other.reacted.users': '{count, plural, one {e mais um} other {e mais {count}}}',
    'fabric.reactions.reactwithemoji': 'Reaja com um emoji {emoji}',
    'fabric.reactions.summary': "Veja todas as rea\xe7\xf5es de usu\xe1rios",
    'reaction-picker-trigger.add.reaction.message': "Adicionar rea\xe7\xe3o",
    'reactions.dialog.close': 'Fechar',
    'reactions.dialog.emoji.name': '{emojiName}',
    'reactions.dialog.left.navigate': 'Navegar para a esquerda',
    'reactions.dialog.reactions.count': "{count, plural, one {{count,number} rea\xe7\xe3o total} other {{count,number} rea\xe7\xf5es totais}}",
    'reactions.dialog.right.navigate': 'Navegar para a direita',
    'reactions.dialog.viewall': 'Ver tudo',
    'reactions.dialog.viewall.tooltip': "Veja todas as rea\xe7\xf5es de usu\xe1rios"
};

});


//# sourceMappingURL=pt_BR.5689797e.js.map
